var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.64649V2.36649C18 1.26649 17.1 0.366486 16 0.366486H2C0.89 0.366486 0 1.26649 0 2.36649V16.3665C0 17.4665 0.89 18.3665 2 18.3665H16C17.1 18.3665 18 17.4665 18 16.3665V14.0865C18.59 13.7365 19 13.1065 19 12.3665V6.36649C19 5.62649 18.59 4.98649 18 4.64649ZM17 6.36649V12.3665H10V6.36649H17ZM2 16.3665V2.36649H16V4.36649H10C8.9 4.36649 8 5.26649 8 6.36649V12.3665C8 13.4665 8.9 14.3665 10 14.3665H16V16.3665H2Z",
    fill: "#219A97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.2c22250b1dc371610c6f4a774350fa75.svg";
export { ForwardRef as ReactComponent };